/**
 * Payments module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import PaidInCashBlock from '@src/Payments/Pages/Blocks/PaidInCashBlock.vue';

export const setup = (app: App<Element>): void => {
    app.component('PaidInCashBlock', PaidInCashBlock);
};
